<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>设备管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>运行设备列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>运行设备列表</span>
        </div>
        <span class="left">
          <el-button type="primary" @click="refresh()" icon="el-icon-refresh" :loading="refresh_loading">同步设备
          </el-button>
        </span>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <!-- <el-form-item label="分类:">
            <el-select v-model="search.type" placeholder="请选择分类">
              <el-option
                v-for="item in category"
                :key="item.id"
                :label="item.zh_title"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item>
            <el-input placeholder="请输入MID" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <!-- <el-table-column prop="dev_id" label=" DID" width="130"></el-table-column> -->
          <el-table-column prop="dev_type" label="设备类型" width="80"></el-table-column>
          <el-table-column prop="devid" label="MID" width="120"></el-table-column>
          <el-table-column prop="dev_id" label="DID" width="140"></el-table-column>
          <el-table-column prop="iccid" label="ICCID" width="200"></el-table-column>
          <el-table-column prop="is_online" label="联网状态" width="80">
            <template slot-scope="scope">
              <el-link v-if="scope.row.is_online == 1" type="success" :underline="false">在线</el-link>
              <el-link v-else type="danger" :underline="false">离线</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="rssi" label="信号" width="60">
            <template slot-scope="scope">
              <svg class="custom-icon" aria-hidden="true" v-if="scope.row.rssi == 31">
                <use xlink:href="#custom-icon-GSM-xinhao2" />
              </svg>
              <svg class="custom-icon" aria-hidden="true" v-else-if="scope.row.rssi >= 15">
                <use xlink:href="#custom-icon-GSM-xinhao-3" />
              </svg>
              <svg class="custom-icon" aria-hidden="true" v-else>
                <use xlink:href="#custom-icon-GSM-xinhao-2" />
              </svg>
            </template>
          </el-table-column>
          <el-table-column prop="times" label="在线时长"></el-table-column>
          <el-table-column prop="int_time" label="激活日期" width="160"></el-table-column>
          <el-table-column prop="exp_time" label="到期日期" width="160">
            <template slot-scope="scope">
              <el-link type="danger" :underline="false" v-if="scope.row.status == 0">{{scope.row.exp_time}}</el-link>
              <el-link type="success" :underline="false" v-else>{{scope.row.exp_time}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.status">正常</el-tag>
              <el-tag type="danger" v-else>过期</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="version" label="版本" width="70"></el-table-column>
          <!-- <el-table-column prop="dev_id" label="中控id" width="150"></el-table-column> -->
          <el-table-column prop="dev_name" label=" 装配车型 " width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.devid, 'users')">绑定/回收</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.devid, 'iccid')">刷新ICCID</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.devid, 'edit')">库仑计校准</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.devid, 'disable')">禁用网络</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.devid, 'desc')">设备备注</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background layout="total,prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      refresh_loading: false,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      search: {
        type: "",
        keys: "",
      },
      category: [],
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
    //that.getCategory();
  },
  methods: {
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      console.log(command);
      switch (command.command) {
        case "edit":
          this.dialogFormSwitch = true;
          break;
        case "users":
          this.$router.push({
            path: "/dev/devusers",
            query: {
              id: command.row,
            },
          });
          break;
        case "del":
          this.del_item(command.row);
          break;
      }
    },
    refresh() {
      this.refresh_loading = true;
      let that = this;
      that.axios.post("/dev/get_dev_list").then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: "同步成功",
          });
          that.refresh_loading = false;
          that.getList();
        }
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/advert/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.search.type = "";
      this.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      formData.type = that.search.type;
      that.axios.post("/dev/devlist", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
    getCategory() {
      let that = this;
      that.axios.post("/advert/getCate").then((res) => {
        if (res) {
          that.category = res.data;
          that.getList();
        }
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>